module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "Slide"
  }, [_c('section', [_c('header', [_c('p', [_c('img', {
    attrs: {
      "src": require("../assets/images/top/img_idea-header.svg"),
      "alt": "理念"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("平成２２年３月に、児童の心身ともに"), _c('br', {
    staticClass: "visible-sm"
  }), _vm._v("健やかな育成に寄与する"), _c('br', {
    staticClass: "hidden-sm"
  }), _vm._v("事を目的に、"), _c('br', {
    staticClass: "visible-sm"
  }), _vm._v("地域とも連携し設立いたしました。")])]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "alignLeft",
    attrs: {
      "src": require("../assets/images/top/img_idea.png"),
      "alt": ""
    }
  }), _vm._v("私たち一般社団法人おやこハグネットは平成２２年３月に、児童の心身ともに健やかな育成に寄与する事を目的に、地域とも連携し設立いたしました。"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      放課後児童クラブでは、“就労中の保護者が子どもさんを、安心して預けられる場所作り”“子どもたちが、安全に安定して過ごせる居心地の良い空間づくり”を目的とし運営しています。"), _c('br'), _vm._v("\n      また人と人のコミュニケーションを大切にし、保護者、学校、地域の方々と連携して子どもたちの健全な育成を行っております。"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      児童家庭支援事業では、山代温泉まちづくり推進協議会と連携し、児童の学習支援をはじめ、今現在地域にある子ども達や子育て家庭が抱える問題を、様々な機関の方々と話し合い、ニーズに対応した支援が出来るよう取り組んでいます。")]), _vm._v(" "), _c('p', {
    staticClass: "sign"
  }, [_c('small', [_vm._v("一般社団法人おやこハグネット")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b921eef2!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/IdeaSlide.vue
// module id = 387
// module chunks = 2